<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <div>
    <dx-data-grid ref='refProductDieGrid'
      id="gridContainer"
      :data-source="productDrawingList"
      :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
      :hover-state-enabled = "true" :allowColumnResizing = 'true'
      column-resizing-mode = 'widget' :allow-column-reordering = "true"
      :height='gridHeight' :row-alternation-enabled="true"
      :focused-row-enabled="true"
      @focused-row-changed="onSelectionChanged"
      :auto-navigate-to-focused-row="false"
      key-expr="seqId"
      :focused-row-key.sync='focusedRowKey'
      @row-removed='onRowRemoved' @row-inserted='onRowInserted' @row-inserting='onRowInserting'
      @row-updated='onRowUpdated' @row-updating='onUpdating'
      @toolbar-preparing='onToolbarPreparingRegProductDrawing'
    >
      <DxSearchPanel
        :visible="true"
        placeholder="검색..."
      />
      <DxExport
        :enabled="true"
        file-name="제품도면정보"
      />
      <DxFilterRow
        :visible="true"
        apply-filter="auto"
      />
      <DxEditing
        :allow-updating="false"
        :allow-deleting="(userInfo.permission & crudAllow) > 0"
        :allow-adding="(userInfo.permission & crudAllow) > 0"
        :use-icons="true"
        mode="row"
      />
      <DxColumn
        caption="품번"
        data-field="품번"
        edit-cell-template="productionGridTemplate"
      >
      <dx-required-rule message="항목을 입력하세요"/>
      </DxColumn>
      \<DxColumn
        data-field="count"
        caption="등록도면수"
        :allowEditing="false"
      />
      <DxColumn
        data-field="품명"
        caption="품명"
        :allowEditing="false"
      />
      <DxColumn
          :allowEditing='false'
          caption="공정명"
          data-field="공정유형"
        >
        <DxLookup
            :data-source="itemTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="자재유형"
          data-field="자재유형"
        >
        <DxLookup
            :data-source="meterialTypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="품목유형"
          data-field="품목유형"
        >
        <DxLookup
            :data-source="productypeLookup"
            display-expr="코드명"
            value-expr="코드"
          />
        </DxColumn>
      <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            show-in-column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
      <template #productionGridTemplate="{ data: cellInfo }">
            <ProductionGridComponent
              :value="cellInfo.value"
              :on-value-changed="cellInfo.setValue"
              @selected-pcode='setProductionCode'
              :productionInfo='productionList'
            />
        </template>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
    </dx-data-grid>
    <!-- <div id="events">
      <div>
        <div class="caption">
          Fired events
        </div>
        <DxButton
          id="clear"
          text="Clear"
          @click="clearEvents()"
        />
      </div>
      <ul>
        <li
          v-for="(event, index) in events"
          :key="index"
        >{{ event }}</li>
      </ul>
    </div> -->
    <DxPopupGen
      :visible.sync="popupProductDrawingFileList"
      :drag-enabled="true"
      :close-on-outside-click="false"
      :show-title="true"
      :width="450"
      :height="250"
      title="도면파일 등록/조회"
    >
      <dx-data-grid ref='refProductDrawingFileGrid'
        :data-source='productDrawingFileList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :row-alternation-enabled="true"
        :focused-row-enabled="false"
        :auto-navigate-to-focused-row="false"
        @row-removed='onFileRowRemoved'
        @toolbar-preparing='onToolbarPreparingRegPressDieFile'
        :height="180"
      >
        <DxEditing
        :allow-deleting="true"
        :use-icons="true"
        mode="row"
        />
        <DxColumn
          :allowEditing='false'
          caption="파일명"
          data-field="파일명"
        >
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="생성일자"
          data-field="createtime"
          format='yyyy-MM-dd HH:mm'
          dataType="date"
        >
        </DxColumn>
        <DxColumn
          width="60"
          :buttons="fileEditButtons"
          type="buttons"
        />
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </DxPopupGen>
    <input id="product-drawing-input" class="inputFile" type="file" name="file" @change="onFileChange" accept="" style='display: none;'>
  </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
// import DxButton from 'devextreme-vue/button'
import DxDataGrid, { DxScrolling, DxColumn, DxEditing, DxSummary, DxTotalItem, DxSearchPanel, DxExport, DxFilterRow, DxLookup, DxPaging, DxSorting } from 'devextreme-vue/data-grid'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'
import ConstDef from '../../share/ConstDef'
import ProductionGridComponent from '../../share/component/ProductionGridComponent'
import AppLib from '../../share/AppLib'
import HttpService from '../../share/service/HttpService'
import axios from 'axios'

export default {
  name: 'login',
  data: function () {
    return {
      crudAllow: ConstDef.CRUD_ALLOW_경영_생산,
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      selectedRow: null,
      tabs: [
        {
          title: '제품도면'
        }
      ],
      productDrawingList: null,
      focusedRowKey: null,
      itemTypeLookup: null,
      meterialTypeLookup: null,
      productypeLookup: null,
      productDrawingFileList: null,
      popupProductDrawingFileList: false,
      fileEditButtons: ['delete',
        {
          hint: '이미지 다운로드',
          icon: 'download',
          visible: 'true',
          onClick: this.onFileDown
        }
      ]
    }
  },
  components: {
    Loading,
    DxScrolling,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxTabPanel,
    DxSummary,
    DxTotalItem,
    DxRequiredRule,
    DxSearchPanel,
    DxExport,
    DxFilterRow,
    DxLookup,
    DxPopupGen,
    DxPaging,
    DxSorting,
    ProductionGridComponent
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.itemTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.공정유형)
    this.meterialTypeLookup = this.$store.getters.getBaseDataByType(ConstDef.자재유형)
    this.productypeLookup = this.$store.getters.getBaseDataByType(ConstDef.품목유형)
    this.refreshProductDrawingList()
    this.refreshProduction()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    // logEvent (eventName) {
    //   this.events.unshift(eventName)
    // },
    // clearEvents () {
    //   this.events = []
    // },
    deleteFile (row, deleteTarget, pathFileName) {
      let jsonData = {}
      if (!Array.isArray(pathFileName)) {
        jsonData = { pathFileName: [ pathFileName ] }
      } else {
        jsonData = { pathFileName: pathFileName }
      }
      const form = new FormData()
      form.append('jsonData', JSON.stringify(jsonData))
      let array = []
      array.push(HttpService.upload(form, '/deleteFile'))
      if (deleteTarget === '제품도면') {
        array.push(this.$_sp.runDeleteProc('spDeleteAllProductDieInfoByKey', [{ 품번: row.data.품번 }]))
      } else {
        array.push(this.$_sp.runDeleteSqlProc('제품도면상세', [{ 품번: row.data.품번, 파일경로: row.data.파일경로 }]))
      }
      axios.all(array)
        .then(axios.spread((...reponse) => {
          if (deleteTarget !== '제품도면') {
            this.selectedRow.count--
          }
          this.$snotify.info('삭제되었습니다.')
        }))
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onToolbarPreparingRegProductDrawing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '제품도면 추가/조회',
            icon: 'download',
            text: '제품도면 추가/조회',
            type: 'default',
            focusStateEnabled: true,
            onClick: (args) => {
              this.popupProductDrawingFileOn()
            }
          }
        }
      )
    },
    onToolbarPreparingRegPressDieFile (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'after',
          widget: 'dxButton',
          options: {
            hint: '파일추가',
            icon: 'add',
            text: '파일추가',
            focusStateEnabled: true,
            onClick: (args) => {
              this.$Q('#product-drawing-input').click()
            }
          }
        }
      )
    },
    onFileRowRemoved (row) {
      let deleteTarget = '제품도면상세'
      this.deleteFile(row, deleteTarget, row.data.파일경로)
      // this.$refs.refProductDrawingFileGrid.instance.refresh()
    },
    onFileDown (e) {
      window.open(ConstDef.apiUrl + `/imgLoadAll?file=` + e.row.data.파일경로)
    },
    onFileChange: function ($event) {
      const fileName = $event.target.files[0].name + ''
      if (fileName === '' || fileName === undefined || fileName === null) {
        return
      }
      let fileType = $event.target.name
      const form = new FormData()
      const file = $event.target.files[0]
      // let waitTime = Math.round(file.size / 870000 * 60)
      // this.$refs.refProgressBar.startProgress(waitTime)
      form.append('file', file)
      form.append('품번', this.selectedRow.품번)
      form.append('fileType', fileType)
      let ver = 1
      if (this.productDrawingFileList.length > 0) {
        let fileName = this.$_.max(this.productDrawingFileList, function (stooge) { return stooge.createtime })
        if (fileName !== null) {
          ver = parseInt((fileName.파일명.split('-ver')[1]).replace('/[^0-9]/g', ''))
          ver = ver + 1
        }
      }
      form.append('fileCnt', ver)
      this.$Q('#product-drawing-input').val('')
      let url = '/productDrawingUpload'
      HttpService.upload(form, url)
        .then((data) => {
          let temp = {
            품번: this.selectedRow.품번,
            파일경로: data.PATH,
            파일명: data.fileName,
            createid: this.userInfo.userId,
            updateid: this.userInfo.userId
          }
          this.$_sp.runInsertSqlProc('제품도면상세', null, [temp])
            .then((data) => {
              this.$snotify.info('저장 되었습니다.')
              this.selectedRow.count++
              this.refreshProductDrawingFileList()
            })
            .catch(error => {
              this.isLoading = false
              if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
                this.$snotify.error(error.response.data.message)
              } else {
                console.log(error)
              }
            })
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === ConstDef.GENERRAL_ERROR || error.response.status === ConstDef.NOT_ACCEPTABLE) {
            this.$snotify.error(error.response.data.message, { timeout: 0 })
          }
        })
    },
    onSelectionChanged (e) {
      this.selectedRow = e.row.data
    },
    onRowRemoved (row) {
      this.$_sp.runNoEncodeFindSqlProc('제품도면상세', { 품번: row.data.품번 })
        .then((data) => {
          this.productDrawingFileList = this.$_sp.MakeModel(data)
          console.log(this.productDrawingFileList)
          let arr = []
          for (var value of this.productDrawingFileList) {
            arr.push(value.파일경로)
          }
          console.log(arr)
          this.deleteFile(row, '제품도면', arr)
          this.selectedRow = null
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserted (row) {
      row.data.updatetime = row.data.createtime = AppLib.getToday()
      row.data.updateid = row.data.createid = this.userInfo.userName
      this.$_sp.runInsertAndFindSqlProc('제품도면', ['품번'], ['seqId', '공정유형', '품명', '품목유형', '자재유형', 'count'], row.data)
        .then((data) => {
          let aa = this.$_sp.MakeModel(data)[0].seqId
          console.log(aa)
          row.data.seqId = aa
          console.log(row.data.seqId)
          this.$snotify.info('추가되었습니다.')
          this.refreshProductDrawingList()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onRowInserting (row) {
      const index = this.$_.findIndex(this.productDrawingList, { 품번: row.data.품번 })
      console.log(index)
      if (index >= 0) {
        this.$snotify.info('품번이 중복 되었습니다.')
        row.cancel = true
      }
    },
    onRowUpdated (row) {
      row.data.updatetime = AppLib.getNow()
      row.data.updateid = this.userInfo.userName
      console.log('save')
      let array = []
      array.push(AppLib.deleteUnderlineKey(row.data))
      this.$_sp.runUpdateSqlProc('제품도면', ['seqId', '품번'], ['공정유형', '품명'], array)
        .then((data) => {
          this.$snotify.info('저장 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    onUpdating (row) {
      console.log('saving')
    },
    popupProductDrawingFileOn (e) {
      if (this.selectedRow === null) {
        this.$snotify.error('해당 행 을 선택해주세요.')
        return false
      }
      this.isLoading = true
      this.refreshProductDrawingFileList()
      this.popupProductDrawingFileList = true
    },
    refreshProductDrawingFileList () {
      this.$_sp.runNoEncodeFindSqlProc('제품도면상세', { 품번: this.selectedRow.품번 })
        .then((data) => {
          this.productDrawingFileList = this.$_sp.MakeModel(data)
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshProductDrawingList () {
      this.$_sp.runNoEncodeFindProc('spFindAllProductDrawingJoinItemInfoAndPdDetail', {})
      // this.$_sp.runNoEncodeFindSqlProc('금형정보', null)
        .then((data) => {
          this.productDrawingList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response !== undefined && error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            console.log(error)
          }
        })
    },
    refreshProduction () {
      // this.$_sp.runNoEncodeFindProc('spFindAllProductByType', {})
      this.$_sp.runNoEncodeFindSqlProc('품목정보', null)
        .then((data) => {
          this.productionList = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    setProductionCode (code) {
      this.selectedProductionCode = code
    }
  }
}
</script>

<style lang="scss">

</style>
